import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=a3ea3b74&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ea3b74')) {
      api.createRecord('a3ea3b74', component.options)
    } else {
      api.reload('a3ea3b74', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=a3ea3b74&", function () {
      api.rerender('a3ea3b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/comp/pricelist.vue"
export default component.exports